"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ApiDropType } from "@/generated/models/ApiDropType";
import { SingleWaveDropInfoContainer } from "./SingleWaveDropInfoContainer";
import { SingleWaveDropInfoDetails } from "./SingleWaveDropInfoDetails";
import { SingleWaveDropContent } from "./SingleWaveDropContent";
import WaveDropDeleteButton from "@/components/utils/button/WaveDropDeleteButton";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import VotingModal from "@/components/voting/VotingModal";
import { WaveDropVoteSummary } from "./WaveDropVoteSummary";
import { WaveDropMetaRow } from "./WaveDropMetaRow";
interface SingleWaveDropInfoPanelProps {
  readonly drop: ExtendedDrop;
}
export const SingleWaveDropInfoPanel = t0 => {
  const $ = _c(29);
  const {
    drop
  } = t0;
  const [isVotingOpen, setIsVotingOpen] = useState(false);
  const {
    canDelete,
    canShowVote,
    isVotingEnded,
    isWinner
  } = useDropInteractionRules(drop);
  let t1;
  if ($[0] !== drop) {
    t1 = <div className="tw-mb-6"><SingleWaveDropContent drop={drop} /></div>;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsVotingOpen(true);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== canShowVote || $[4] !== drop || $[5] !== isVotingEnded || $[6] !== isWinner) {
    t3 = <div className="tw-mb-6"><WaveDropVoteSummary drop={drop} isWinner={isWinner} isVotingEnded={isVotingEnded} canShowVote={canShowVote} onVoteClick={t2} /></div>;
    $[3] = canShowVote;
    $[4] = drop;
    $[5] = isVotingEnded;
    $[6] = isWinner;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== drop || $[9] !== isWinner) {
    t4 = <WaveDropMetaRow drop={drop} isWinner={isWinner} />;
    $[8] = drop;
    $[9] = isWinner;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== drop) {
    t5 = <div className="tw-mt-6"><SingleWaveDropInfoDetails drop={drop} /></div>;
    $[11] = drop;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== canDelete || $[14] !== drop) {
    t6 = canDelete && drop.drop_type !== ApiDropType.Winner && <div className="tw-w-full tw-pb-6 tw-pt-6 tw-border-t tw-border-iron-800 tw-border-solid tw-border-x-0 tw-border-b-0"><WaveDropDeleteButton drop={drop} /></div>;
    $[13] = canDelete;
    $[14] = drop;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t1 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = <SingleWaveDropInfoContainer><div className="tw-px-4 @[640px]:tw-px-8 tw-pb-8 @[640px]:tw-pb-10"><div className="tw-max-w-3xl tw-mx-auto">{t1}{t3}{t4}{t5}{t6}</div></div></SingleWaveDropInfoContainer>;
    $[16] = t1;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsVotingOpen(false);
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== drop || $[24] !== isVotingOpen) {
    t9 = <VotingModal drop={drop} isOpen={isVotingOpen} onClose={t8} />;
    $[23] = drop;
    $[24] = isVotingOpen;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t7 || $[27] !== t9) {
    t10 = <>{t7}{t9}</>;
    $[26] = t7;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};